import { IContentSet } from "../interfaces/content/content-set.model.interface";
import { IProperty } from "../interfaces/property/property.model.interface";
import { IState } from "../interfaces/config/state.model.interface";
import { IDevice } from "../interfaces/device/device.model.interface";
import { IContentType } from "@/models/interfaces/content/content-type-model.interface";
import { EnquiryType } from "../../enums/EnquiryType";
import { State } from "../config/state.model";

export class ContentSetModel implements IContentSet {
    public contentSetId: number;
    public name: string;
    public description: string;
    public createdDate: Date;
    public productCategoryId: number;
    public productBrandId: number | null;
    public processId: number;
    public allowMultivariate: boolean;
    public templateCount: number;
    public state: IState;
    public properties: IProperty[];
    public devices: IDevice[];
    public enquiryTypes: EnquiryType[];
    public contentTypes: IContentType[];

    constructor() {
        this.contentSetId = 0;
        this.name = "";
        this.description = "";
        this.createdDate = new Date();
        this.productCategoryId = 1;
        this.productBrandId = 0;
        this.processId = 1;
        this.allowMultivariate = true;
        this.templateCount = 0;
        this.state = new State();
        this.properties = [];
        this.devices = [];
        this.enquiryTypes = [];
        this.contentTypes = [];
    }
}
